import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CenterCard from './center_card';
import ErrorType from './types/error_type';
import {
  clearError, endSession,
} from '../modules/session';

import Loading from './loader_wave';
import ErrorMessage from './error_message';
import getParams from './utils/getParams';

class SignOut extends Component {
  constructor(props) {
    super(props);
    const { connectedClearError } = props;
    connectedClearError();
  }

  componentDidMount() {
    const { connectedEndSession } = this.props;
    const { from } = getParams(window.location);
    connectedEndSession({ reload: false, from });
  }

  render() {
    const { error, signOutRequestOut } = this.props;
    const msg = (error && error.error && error.error.message)
      || 'Unable to end the current session.';
    return (
      <CenterCard routeName="Sign Out">
        { signOutRequestOut && <Loading /> }
        { error && <ErrorMessage message={msg} /> }
      </CenterCard>
    );
  }
}

SignOut.propTypes = {
  connectedClearError: PropTypes.func.isRequired,
  connectedEndSession: PropTypes.func.isRequired,
  error: ErrorType,
  signOutRequestOut: PropTypes.bool.isRequired,
};

SignOut.defaultProps = {
  error: undefined,
};

const mapStateToProps = (state) => ({
  error: state.session.error,
  signOutRequestOut: state.session.signOutRequestOut,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedClearError: clearError,
  connectedEndSession: endSession,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignOut);
